import { z } from "zod";
import { identityBlock, futureDateIso } from "./common.js";
export const piPayloadSchema = identityBlock.extend({
    applyingAsFirm: z.boolean().default(false),
    firmName: z.string().optional(),
    /** Limit of Indemnity in KES (matches rate bands). */
    limitOfIndemnityKes: z.number().int().positive(),
    coverStartDate: futureDateIso,
}).refine((v) => !v.applyingAsFirm || (v.firmName && v.firmName.length > 0), { message: "Firm Name is required when applying as a Firm", path: ["firmName"] });
